export const Select = {
  variant_classes: {
    default: {
      main: "select",
      dropdown: "select-dropdown",
      active: "select-active",
    },
    "role-selector": {
      main: "select-role",
      dropdown: "select-role-dropdown",
      active: "select-role-active",
    },
  },
  mounted() {
    const variant_classes = this.variant_classes[this.el.dataset.variant]
    const select = this.el.querySelector(`.${variant_classes.main}`)
    const selectDropdown = this.el.querySelector(`.${variant_classes.dropdown}`)

    select.addEventListener("click", (e) => {
      if (!select.classList.contains("select-disabled")) {
        const listItem = e.target.closest(`.${variant_classes.dropdown} li`)
        if (listItem) this.selectListItem(listItem)
        select.classList.toggle(variant_classes.active)
      }
    })
    select.addEventListener("focusout", (e) => {
      if (!e.relatedTarget || !select.contains(e.relatedTarget)) {
        select.classList.remove(variant_classes.active)
      }
    })
    select.addEventListener("keydown", (event) => {
      if (event.key == "Escape") {
        select.classList.remove(variant_classes.active)
      }
    })

    this.addEventListenerAccountStageUnchanged()

    this.addEventListenerProspectOrClientStageUnchanged()

    this.addEventListenerDealStageUnchanged()
  },

  selectListItem(li) {
    if (!li.hasAttribute("phx-click")) {
      const choice = li.querySelector("span")
      const dest = this.el.querySelector(".select-description")

      // Skip DOM manipulation for LiveView-managed selects
      if (!this.el.hasAttribute("data-liveview-managed")) {
        dest.innerHTML = choice.innerHTML
      }

      const selectElement = this.el.querySelector("select")
      selectElement.value = choice.dataset.value
      selectElement.dispatchEvent(new Event("input", { bubbles: true }))
    }
  },

  // The server pushes the *_stage_unchanged events to every mounted Select hook, so
  // the payload names the select to revert (ENA-9702) and each hook acts only on
  // its own. Both AccountModal instances render a stage selector, and they can be
  // showing different accounts, so a document-wide lookup would let one instance
  // rewrite the other's label with the wrong account's stage.
  revertStageSelection(selectId, stage) {
    if (!selectId) return

    const select = this.el.querySelector(`select[id="${selectId}"]`)
    if (!select) return

    const option = select.querySelector(`option[value="${stage}"]`)
    if (!option) return

    select.selectedIndex = option.index

    const description = this.el.querySelector(".select-description")
    if (description) description.textContent = option.text
  },

  addEventListenerAccountStageUnchanged() {
    this.handleEvent("account_stage_unchanged", ({ stage, select_id }) => {
      this.revertStageSelection(select_id, stage)
    })
  },

  addEventListenerProspectOrClientStageUnchanged() {
    this.handleEvent(
      "prospect_or_client_stage_unchanged",
      ({ stage, select_id }) => {
        this.revertStageSelection(select_id, stage)
      },
    )
  },

  addEventListenerDealStageUnchanged() {
    const variant_classes = this.variant_classes[this.el.dataset.variant]
    this.handleEvent("deal_stage_unchanged", ({ stage }) => {
      let opts = document.getElementById("deal_stage_form_stage")
      let stageIndex = (document.querySelector("select").selectedIndex =
        document.querySelector(`option[value=${stage}]`).index)
      let stageDescription = opts[stageIndex].text

      let customSelect =
        document.getElementsByClassName("select-description")[0]
      customSelect.textContent = stageDescription
    })
  },
}
